import { Leaf } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[var(--border-line)] mt-24">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <Leaf className="w-5 h-5 text-[var(--forest)]" strokeWidth={1.5} />
            <span className="font-serif text-2xl">Wild Vitality</span>
          </div>
          <p className="mt-4 text-sm text-[var(--ink-soft)] max-w-xs leading-relaxed">
            A field guide to the wild plants growing at your feet — and how to
            use them to feel measurably alive again.
          </p>
        </div>

        <div>
          <p className="label-eyebrow">The Library</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/library?cat=weight_loss" className="btn-ghost p-0">Weight Loss</Link></li>
            <li><Link to="/library?cat=detox" className="btn-ghost p-0">Detox & Heavy Metals</Link></li>
            <li><Link to="/library?cat=cognitive" className="btn-ghost p-0">Cognitive Health</Link></li>
            <li><Link to="/library?cat=general_wellness" className="btn-ghost p-0">General Wellness</Link></li>
          </ul>
        </div>

        <div>
          <p className="label-eyebrow">Important</p>
          <p className="mt-4 text-xs leading-relaxed text-[var(--ink-soft)]">
            This site is informational. Nothing here is medical advice. Always
            confirm plant identity with a second source, and consult a qualified
            practitioner before changing medications or starting heavy-metal
            detoxification.
          </p>
        </div>
      </div>
      <div className="border-t border-[var(--border-line)] py-5 text-center text-xs text-[var(--muted)]">
        © {new Date().getFullYear()} Wild Vitality. Printed on parchment, watered by rain.
      </div>
    </footer>
  );
}
